import { render } from "./LogicCalculationsRoute.vue?vue&type=template&id=bef3a410&scoped=true"
import script from "./LogicCalculationsRoute.vue?vue&type=script&lang=js"
export * from "./LogicCalculationsRoute.vue?vue&type=script&lang=js"

import "./LogicCalculationsRoute.vue?vue&type=style&index=0&id=bef3a410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef3a410"]])

export default __exports__